/**
 * @author - steves165
 *
 *
 */
(function() {
	'use strict';

    function uniq(input) {
        var collected = input.reduce(function(collector, next) {
            collector[next.format('MMM YYYY')] = next;

            return collector;
        }, Object.create(null));

        return Object.keys(collected).map(function(key) {
            return collected[key];
        });
    }

	angular.module('vhols')

		.controller('ActivityController', ['$scope', '$rootScope', 'deviceDetection', function($scope, $rootScope, deviceDetection) {
			$scope.init = function(searchPanel, searchLocation) {
			    $scope.device = deviceDetection.getDevice();
                $scope.hideCrumbs = $scope.device != 'Desktop';

				// search panel setting
                if (searchPanel && searchPanel !== "") {
                    var criteria = {
                            selectedBookingType: {
                                brand: 205,
                                id: parseInt(searchPanel, 10)
                            }
                        };
                    if(searchLocation && searchLocation !== '') {
                        criteria.selectedChildLocation = {
                            locationUrlDescription: searchLocation
                        };
                    }
                    $rootScope.$emit('SearchPanel:populate', criteria);
                }
			};

            $scope.toggleHideCrumbs = function(){
                $scope.hideCrumbs = !$scope.hideCrumbs;
            };

			$scope.getDurationObject = function(duration){
			    var durationObject = {};
			    if(duration){
                    var durationArr = duration.trim().split(' ');
                    durationObject.durationNumber = durationArr[0] || '';
                    durationObject.durationType = durationArr[1] || '';
                }else{
                    durationObject.durationNumber = '';
                    durationObject.durationType = '';
                }
			    return durationObject;
            };
		}])

		.controller('ActivityListFilterController', ['$scope', 'activityFilters', function($scope, activityFilters) {
			var activities = $scope.activities.slice(0);

			$scope.hideFilters = true;

			var mediator = activityFilters($scope.activities);
			mediator.addListener(function(eventName, filtered) {
				$scope.$parent.activities = activities.filter(eventName === "change" ? ecmsFilter(filtered) : returnTrue);
			});

			function ecmsFilter(filtered) {
				return function(activity) {
                    return activity.locations.some(function(location){
                        return filtered.indexOf(location.id) > -1;
                    });
				};
			}

			function returnTrue() {
				return true;
			}

			$scope.mediator = mediator;

		}])

        .controller('ToursCruisesListFilterController', ['$scope', 'toursCruisesFilters', function($scope, toursCruisesFilters) {

            var activities = $scope.activities.slice(0);

			$scope.hideFilters = true;

			var mediator = toursCruisesFilters($scope.hierarchy);
			mediator.addListener(function(eventName, filtered) {
				$scope.$parent.activities = activities.filter(eventName === "change" && filtered.length > 0 ? toursCruisesListFilter(filtered) : returnTrue);
			});

			function toursCruisesListFilter(filtered) {
				return function(activity) {
					return filtered.indexOf(activity.tbxId) > -1;
				};
			}

			function returnTrue() {
				return true;
			}

			$scope.mediator = mediator;

		}])

        .controller('ActivityPricing', ['$scope', 'price', function($scope, Price) {
            var startDatesTmp = [];
            var endDatesTmp = [];

            $scope.prices = [];

            //Filter models
            $scope.specialOffersFilter = false;

            $scope.$watch('pricing', function() {
                if ($scope.pricing) {
                    var prices = JSON.parse($scope.pricing.prices);

                    prices.forEach(function(price) {
                        var priceObj = new Price(price.adultPrice,
                               price.adultSaving,
                               price.freeText,
                               price.departureStartDate,
                               price.departureEndDate);

                        $scope.prices.push(priceObj);

                        startDatesTmp.push(priceObj.startDate);
                        endDatesTmp.push(priceObj.endDate);
                    });

                    $scope.startDates = uniq(startDatesTmp);
                    $scope.endDates = uniq(endDatesTmp);
                }
            });
        }]);
})();
